import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import { SubAbasEmpenhos, SubAbasEmpenhosNovo } from './subabasEmpenhos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { ProaqDestaque } from '../../../../modules/types/Proaq';
import { LogData } from '../../../../modules/types/types';
import { useNivelCriticidade } from '../../../../services/enum/useNivelCriticidade';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { getDestaquesByProaqId } from '../../../../services/processosAquisitivos/proaqDestaquesService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
} from '../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';
import {
  fieldObjectProaq,
  headersProaqDestaques,
  valoresExibidosProaq,
} from '../../ProcessosAquisitivos/auxiliarProaq';

// Dados do usuário
//Dados do usuário
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Proaq_Destaque;

const EmpenhosDestaque: React.FC = () => {
  // const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  let subAbas;
  const NivelCriticidade = useNivelCriticidade();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [logData, setLogData] = useState<LogData>();
  const [destaqueId, setDestaqueId] = useState<string>('');
  const [updating, setUpdating] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  const [formDestaque, setFormDestaque] = useState<ProaqDestaque>({
    id: 0,
    descricao: '',
    nivelCriticidade: 0,
    observacoes: '',
    titulo: '',
    proaqId: parseInt(fichaID, 10),
    usuarioId: userID,
  });

  //Subabas
  if (fichaID !== 'undefined') {
    subAbas = SubAbasEmpenhos(fichaID);
  } else {
    subAbas = SubAbasEmpenhosNovo;
  }

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Atualizar Registro';
  } else {
    tituloModal = 'Novo Registro';
  }
  const iconeModal = 'account_tree';

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const destaques = await getDestaquesByProaqId(id);
      setData(destaques);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };

  useEffect(() => {
    fetchData(fichaID);
  }, []);

  //Dados da tabela
  const tableDataDestaques = data
    ? data.map((item: ProaqDestaque) => ({
        id: item.id,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
      }))
    : [];

  //Dados do Offcanvas
  const offCanvasData = data
    ? data.map((item: any) => ({
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,
      }))
    : [];

  const exportData = data
    ? data.map((item: any) => ({
        //Dados da entidade
        id: item.id,
        nivelCriticidade: NivelCriticidade[item.nivelCriticidade].label,
        titulo: item.titulo,
        descricao: item.descricao,
        observacoes: item.observacoes,

        //Dados do Fornecedor
        proaq: item.proaq.id,
        denominacaoGenerica:
          item.proaq.denominacaoGenerica &&
          item.proaq.denominacaoGenerica != null
            ? item.proaq.denominacaoGenerica.denominacaoGenerica
            : null,
        KitProdutoDAF:
          item.proaq.KitProdutoDAF && item.proaq.KitProdutoDAF != null
            ? item.proaq.KitProdutoDAF.nomeKit
            : null,
        //Logs
        dataRegistro: item.dataRegistro,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioRegistro: formataNomeMeioSiglas(
          item.usuarioRegistro.nomeCompleto,
        ),
        usuarioAtualizacao: formataNomeMeioSiglas(
          item.usuarioAtualizacao.nomeCompleto,
        ),
        usuarioUltimaVisualizacao: formataNomeMeioSiglas(
          item.usuarioUltimaVisualizacao.nomeCompleto,
        ),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
      }))
    : [];

  //Funções Handle

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    if (name == 'nivelCriticidade') {
      setFormDestaque({
        ...formDestaque,
        nivelCriticidade: newValue,
      });
    } else {
      setFormDestaque((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearForm = () => {
    setFormDestaque({
      ...formDestaque,
      id: 0,
      descricao: '',
      nivelCriticidade: 0,
      observacoes: '',
      titulo: '',
      proaqId: parseInt(fichaID, 10),
      usuarioId: userID,
    });
  };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdating(false);
    handleShowModal();
  };

  const handleRowClick = (id: string) => {
    setDestaqueId(id);
    setUpdating(true);
    setShowModal(true);
    data
      .filter((item: any) => item.id == id)
      .map((item: any) => {
        setFormDestaque({
          id: item.id,
          nivelCriticidade: item.nivelCriticidade,
          titulo: item.titulo,
          descricao: item.descricao,
          observacoes: item.observacoes,

          // chave usuário
          usuarioId: userID,
          // chave fornecedor
          proaqId: parseInt(fichaID, 10),
        });
        setLogData({
          id: item.id,
          usuarioRegistro: item.usuarioRegistro.nomeCompleto || '',
          usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto || '',
          dataRegistro: item.dataRegistro,
          dataAtualizacao: item.dataUltimaAtualizacao,
          nEdicoes: item.nEdicoes,
        });
      });
  };

  function validateForm(form: any) {
    const erros: string[] = [];

    if (form.titulo === '') {
      erros.push('<b>Título</b> é obrigatório.');
    }

    if (form.titulo === '') {
      erros.push('<b>Descrição</b> é obrigatória.');
    }

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  }

  const handleCreate = async () => {
    try {
      // const token = 'JWT_SECRET';

      const isFormValido = validateForm(formDestaque);
      if (!isFormValido) throw new Error('Formulário inválido.');

      await httpClient.post(`/api/proaqdestaque`, formDestaque);

      swalSave();
      fetchData(fichaID);
      setTimeout(() => handleShowModal(), 2500);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      console.log('Erro: ', error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      const isFormValido = validateForm(formDestaque);
      if (!isFormValido) throw new Error('Formulário inválido.');

      const response = await httpClient.patch(
        `/api/proaqdestaque/${destaqueId}`,
        formDestaque,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.proaq.id);
      setTimeout(() => {
        handleShowModal();
      }, 2000);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/proaqdestaque/${destaqueId}`);
        swalDeleteConfirm();
        fetchData(fichaID);
        setTimeout(() => {
          handleShowModal();
        }, 2000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/empenhos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <BoxConteudo boxTitulo="Informações do Destaque">
              <CustomRow style={{ marginTop: '10px' }}>
                <CustomCol width="20%">
                  <Select
                    name="nivelCriticidade"
                    value={formDestaque.nivelCriticidade}
                    options={NivelCriticidade}
                    onChange={handleChange}
                    label="Criticidade"
                  />
                </CustomCol>
                <CustomCol width="80%">
                  <Input
                    name="titulo"
                    value={formDestaque.titulo}
                    id="titulo"
                    label="Título"
                    onChange={handleChange}
                    required
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <Col>
                  <Input
                    name="descricao"
                    type="textarea"
                    value={formDestaque.descricao}
                    id="descricao"
                    label="Descrição"
                    linhas={4}
                    onChange={handleChange}
                    required
                  />
                </Col>
              </CustomRow>
            </BoxConteudo>

            <BoxConteudo boxTitulo="Observações Gerais">
              <CustomRow>
                <Col>
                  <Input
                    id="observacoes"
                    type="textarea"
                    name="observacoes"
                    value={formDestaque.observacoes}
                    linhas={3}
                    onChange={handleChange}
                  />
                </Col>
              </CustomRow>
            </BoxConteudo>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>

        <Tabela
          dataTable={tableDataDestaques}
          headers={headersProaqDestaques}
          displayValues={valoresExibidosProaq}
          dataOffCanvas={offCanvasData}
          onRowClick={handleRowClick}
          botaoAbrirOffCanvas={false}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidosProaq,
              fieldObjectProaq,
              'sisaf_proaq_destaques.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserirNovo}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default EmpenhosDestaque;
